import React from 'react';

const Loader = () => {
    return (
        <div id="preloader" className="loader_show">
            <div className="loader-wrap">
                <div className="loader">
                    <div className="loader-inner"></div>
                </div>
            </div>
        </div>
    );
};

export default Loader;